webpackJsonp([267847366897727],{

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Main = __webpack_require__(40);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(39);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PageHeader = __webpack_require__(45);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(44);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Seo = __webpack_require__(76);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Footer = __webpack_require__(105);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {};
	};
	
	var SunLipProtection = function SunLipProtection() {
	  var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8;
	
	  var data = {
	    frontmatter: {
	      title: "Best lip sun protection",
	      description: "The top lip balm sunscreens for long sessions in the ocean",
	      cover: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20230721_112816_ewjcxp.jpg"
	    }
	  };
	  var facebook = {};
	  return _react2.default.createElement(
	    _Main2.default,
	    null,
	    _react2.default.createElement(
	      _Article2.default,
	      null,
	      _react2.default.createElement(_PageHeader2.default, {
	        title: "Best lip sun protection",
	        subTitle: "The top lip balm sunscreens for long sessions in the ocean"
	      }),
	      _react2.default.createElement("img", {
	        src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20230721_112816_ewjcxp.jpg",
	        style: { width: "100%", margin: "0 0 1.5em 0" }
	      }),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        "I don't know about you, but my lips used to constantly get burned surfing, especially just above my top lip and on my bottom lip during 2 hour sessions in the ocean.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "So a couple years ago, having located minimal info online, I started experimenting with different lip balm sunscreens with SPF. I found out that barely any of them stay on my lips long enough for a 2 hour session - only one combined chemical/mineral sunscreen does (my top choice, but it's not a lip balm!). Furthermore, I have found only one mineral, and therefore reef-safe, sunscreen that stays on close to 2 hours. Here are my top lip balm sunscreen choices currently on the market."
	      ),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Watermans High Performance Sunscreen and FacePro Performance Stick"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895574/project_surf_helmet/PXL_20240727_184456495.PORTRAIT_geu8r4.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": Just finished testing this stuff in a variety of conditions for long periods of time in the water. It is a really amazing product which stays on your lips and face effectively. My theory is it has a lot to do with the beeswax; years ago I tried a sunscreen with beeswax that was almost impossible to scrub off. Although I don't know exactly what it is that gives it its holding ability, it seems like their Aqua-Armor tech definitely works. Unfortunately, it looks like the sunscreen tube version has chemicals in it - possibly making it not reef-safe - but the FacePro stick does not.",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://gowatermans.com/",
	                target: "_blank",
	                style: (_ref = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref["textAlign"] = "center", _ref.paddingLeft = "20px", _ref.paddingRight = "20px", _ref.height = "45px", _ref.minWidth = "100px", _ref.backgroundColor = "inherit", _ref.color = "#010101", _ref["border"] = "1px solid #010101", _ref["fontWeight"] = 600, _ref.textDecoration = "none", _ref.paddingTop = "7.5px", _ref.paddingBottom = "8.5px", _ref)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://amzn.to/3XdAfQC",
	                target: "_blank",
	                style: (_ref2 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref2["textAlign"] = "center", _ref2.paddingLeft = "20px", _ref2.paddingRight = "20px", _ref2.height = "47px", _ref2.minWidth = "100px", _ref2.backgroundColor = "#ee5a5a", _ref2.marginLeft = "30px", _ref2["fontWeight"] = 600, _ref2.textDecoration = "none", _ref2.paddingTop = "9px", _ref2.paddingBottom = "10px", _ref2)
	              },
	              "Amazon price"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Shiseido Ultimate Sun Protector Face Cream with SynchroShield"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895574/project_surf_helmet/20230721_112513_mmkklr.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": I don't know what they're doing with their SynchroShield tech, but the stuff just doesn't come off except with a hard scrub in the shower. Perfect for someone who apparently subconsiously rubs and licks his own lips. It will make you look like a vampire (yes it leaves a white residue) and has a slight chemical, perfume-like smell and taste, but it's well worth it when the UV index is high and most damaging during long sessions in the ocean. I'm talking about those sessions when you start thinking about what your skin is going to look like later in life... I should mention that it's technically not reef safe, so please only use it on your lips & face in the ocean when you need it most.",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.shiseido.com/us/en/ultimate-sun-protector-cream-spf-50-sunscreen-0730852156760.html",
	                target: "_blank",
	                style: (_ref3 = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref3["textAlign"] = "center", _ref3.paddingLeft = "20px", _ref3.paddingRight = "20px", _ref3.height = "45px", _ref3.minWidth = "100px", _ref3.backgroundColor = "inherit", _ref3.color = "#010101", _ref3["border"] = "1px solid #010101", _ref3["fontWeight"] = 600, _ref3.textDecoration = "none", _ref3.paddingTop = "7.5px", _ref3.paddingBottom = "8.5px", _ref3)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.amazon.com/Shiseido-Protector-Sunscreen-SynchroShield-HeatForce/dp/B0859R8S5N?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=cefaf54c82ed6a3aa2e31cd0fc4bf2a4&camp=1789&creative=9325",
	                target: "_blank",
	                style: (_ref4 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref4["textAlign"] = "center", _ref4.paddingLeft = "20px", _ref4.paddingRight = "20px", _ref4.height = "47px", _ref4.minWidth = "100px", _ref4.backgroundColor = "#ee5a5a", _ref4.marginLeft = "30px", _ref4["fontWeight"] = 600, _ref4.textDecoration = "none", _ref4.paddingTop = "9px", _ref4.paddingBottom = "10px", _ref4)
	              },
	              "Amazon price"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Raw Elements Face & Body"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20230721_112333_xuauxx.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": This stuff is soft and buttery to the touch, really stays on, protects well, and doesn't have a sour, chemical taste. Everything you could want for a reef-safe sunscreen. However, don't expect it to prevent burns in a 2 hour session - although it stays on better than other sunscreens I tested, if you subconsciously rub your lips it will eventually rub off.",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.rawelementsusa.com/products/face-body-30-tin-plastic-free",
	                target: "_blank",
	                style: (_ref5 = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref5["textAlign"] = "center", _ref5.paddingLeft = "20px", _ref5.paddingRight = "20px", _ref5.height = "45px", _ref5.minWidth = "100px", _ref5.backgroundColor = "inherit", _ref5.color = "#010101", _ref5["border"] = "1px solid #010101", _ref5["fontWeight"] = 600, _ref5.textDecoration = "none", _ref5.paddingTop = "7.5px", _ref5.paddingBottom = "8.5px", _ref5)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.amazon.com/Raw-Elements-Certified-Sunscreen-Moisturizing/dp/B01H3PN27M?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=f7357c20d01f0a0137ca3dfd232ece35&camp=1789&creative=9325",
	                target: "_blank",
	                style: (_ref6 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref6["textAlign"] = "center", _ref6.paddingLeft = "20px", _ref6.paddingRight = "20px", _ref6.height = "47px", _ref6.minWidth = "100px", _ref6.backgroundColor = "#ee5a5a", _ref6.marginLeft = "30px", _ref6["fontWeight"] = 600, _ref6.textDecoration = "none", _ref6.paddingTop = "9px", _ref6.paddingBottom = "10px", _ref6)
	              },
	              "Amazon price"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Shiseido Clear Stick UV Protector with WetForce"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895626/project_surf_helmet/20230721_112732_i4hdzf.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": Performs and protects almost as well as the Ultimate Sun Protector Face Cream but leaves no white residue.",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.shiseido.com/us/en/clear-sunscreen-stick-spf-50-0730852169807.html",
	                target: "_blank",
	                style: (_ref7 = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref7["textAlign"] = "center", _ref7.paddingLeft = "20px", _ref7.paddingRight = "20px", _ref7.height = "45px", _ref7.minWidth = "100px", _ref7.backgroundColor = "inherit", _ref7.color = "#010101", _ref7["border"] = "1px solid #010101", _ref7["fontWeight"] = 600, _ref7.textDecoration = "none", _ref7.paddingTop = "7.5px", _ref7.paddingBottom = "8.5px", _ref7)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.amazon.com/Shiseido-Ultimate-Protector-Lotion-Broad-Spectrum/dp/B0921KVV27?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=35d88ac04112180c10c1cd9d235d0ab4&camp=1789&creative=9325",
	                target: "_blank",
	                style: (_ref8 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref8["textAlign"] = "center", _ref8.paddingLeft = "20px", _ref8.paddingRight = "20px", _ref8.height = "47px", _ref8.minWidth = "100px", _ref8.backgroundColor = "#ee5a5a", _ref8.marginLeft = "30px", _ref8["fontWeight"] = 600, _ref8.textDecoration = "none", _ref8.paddingTop = "9px", _ref8.paddingBottom = "10px", _ref8)
	              },
	              "Amazon price"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Notable Mentions that I've tested"
	        ),
	        "These all worked decently, but didn't stand the test of a 2 hour session.",
	        _react2.default.createElement(
	          "h4",
	          null,
	          _react2.default.createElement(
	            "a",
	            {
	              target: "_blank",
	              href: "https://www.amazon.com/Headhunter-Chapstick-Sunscreen-Protection-Waterproof/dp/B08MDP5XD1?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=b36946e52a4bab3a38d279e2dea79d29&camp=1789&creative=9325"
	            },
	            "Head Hunter Lip Protectant"
	          )
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          _react2.default.createElement(
	            "a",
	            {
	              target: "_blank",
	              href: "https://www.amazon.com/Vertra-Ehukai-Beige-Face-Stick/dp/B07RZM1Q34?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=a908e9ca60a9cffa0527e3901f9c2ccd&camp=1789&creative=9325"
	            },
	            "Vertra Sunscreen Face Stick"
	          )
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          _react2.default.createElement(
	            "a",
	            {
	              target: "_blank",
	              href: "https://www.amazon.com/Vertra-Lava-Hibiscus-Lip-Balm/dp/B07PB49DPD?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=47def20bc62fe604b5317443ca202027&camp=1789&creative=9325"
	            },
	            "Vertra Lip Balm"
	          )
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          _react2.default.createElement(
	            "a",
	            {
	              target: "_blank",
	              href: "https://www.amazon.com/Sun-Bum-SPF-Signature-Balm/dp/B07DFSSN6T?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=81d4561dc1639fd163ce2d81dabefc86&camp=1789&creative=9325"
	            },
	            "Sun Bum Signature Lip Balm"
	          )
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          _react2.default.createElement(
	            "a",
	            {
	              target: "_blank",
	              href: "https://www.amazon.com/Beach-Day-Bundle-TropicSport-Sunscreen/dp/B08J4BR35M?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=62d60e55a6aa8ccf071d3eccfc03e1fd&camp=1789&creative=9325"
	            },
	            "TropicSport"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { footnote: data }),
	    _react2.default.createElement(_Seo2.default, { data: data, facebook: facebook, page: true })
	  );
	};
	
	SunLipProtection.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(SunLipProtection);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-lip-sun-protection-js-c3f59843fdde12c8e7e8.js